import { render } from "./top-commodity-section.vue?vue&type=template&id=2131145f&scoped=true&ts=true"
import script from "./top-commodity-section.vue?vue&type=script&lang=ts"
export * from "./top-commodity-section.vue?vue&type=script&lang=ts"

import "./top-commodity-section.vue?vue&type=style&index=0&id=2131145f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131145f"]])

export default __exports__